import { normalizeData, buildSVG } from "./scene"
import { setupEvents } from "./events"
import { HighlightLayer } from "./highlight"
import { OutlineLayer } from "./outline"
import { PanZoom } from "./pan-zoom"

// The interval in ms at which the node lights are toggled on and off.
const BLINK_INTERVAL = 360

export class VDC2dRenderer {
  constructor(wrapperId, vdcData, assets2d) {
    const wrapper = document.getElementById(wrapperId)
    const data = normalizeData(vdcData)
    const svg = buildSVG(wrapper, data, assets2d)
    const scene = svg.querySelector(".vdc2d-scene")

    this.wrapper = wrapper
    this.data = data
    this.svg = svg
    this.highlightLayer = new HighlightLayer(
      svg.querySelector(".node-highlight-layer"),
      data.nodeBoundsById,
    )
    this.outlineLayer = new OutlineLayer(
      svg.querySelector(".node-outline-layer"),
      data.nodeBoundsById,
    )
    this.panZoom = new PanZoom(svg, scene, wrapper)
    this.panZoom.fitToView()
    this.panZoom.onCursorUpdate = this.updateCursor.bind(this)

    this.hoveredNodeId = null
    this.onNodeHover = this.onNodeHover.bind(this)
    this.onNodeUnhover = this.onNodeUnhover.bind(this)
    wrapper.addEventListener("nodehover", this.onNodeHover)
    wrapper.addEventListener("nodeunhover", this.onNodeUnhover)

    this.cleanupEvents = setupEvents(svg, wrapper, data, this.panZoom)

    this.toggleNodeLightLayer = this.toggleNodeLightLayer.bind(this)
    this.interval = setInterval(this.toggleNodeLightLayer, BLINK_INTERVAL)

    this.updateCursor()
  }

  toggleNodeLightLayer() {
    const layer = this.svg.querySelector(".node-with-lights-layer")
    if (layer.style.display === "none") {
      layer.style.display = "block"
    } else {
      layer.style.display = "none"
    }
  }

  onNodeHover(event) {
    this.hoveredNodeId = event.detail.node.id
    this.updateCursor()
  }

  onNodeUnhover(event) {
    if (this.hoveredNodeId === event.detail.node.id) {
      this.hoveredNodeId = null
      this.updateCursor()
    }
  }

  updateCursor() {
    if (this.panZoom.isPanning) {
      this.svg.style.cursor = "grabbing"
    } else if (this.hoveredNodeId) {
      this.svg.style.cursor = "pointer"
    } else {
      this.svg.style.cursor = "grab"
    }
  }

  highlightNode(nodeId, colour) {
    this.highlightLayer.highlight(nodeId, colour)
  }

  unhighlightNode(nodeId) {
    this.highlightLayer.unhighlight(nodeId)
  }

  highlightNodes(nodeIds, colour) {
    for (let i = 0; i < nodeIds.length; i++) {
      this.highlightNode(nodeIds[i], colour)
    }
  }

  unhighlightNodes(nodeIds) {
    for (let i = 0; i < nodeIds.length; i++) {
      this.unhighlightNode(nodeIds[i])
    }
  }

  outlineNode(nodeId) {
    this.outlineLayer.outline(nodeId)
  }

  unoutlineNode(nodeId) {
    this.outlineLayer.unoutline(nodeId)
  }

  outlineNodes(nodeIds) {
    this.outlineLayer.outlineMany(nodeIds)
  }

  unoutlineNodes(nodeIds) {
    this.outlineLayer.unoutlineMany(nodeIds)
  }

  destroy() {
    if (this.interval) {
      clearInterval(this.interval)
    }
    if (this.panZoom) {
      this.panZoom.destroy()
    }
    if (this.cleanupEvents) {
      this.cleanupEvents()
    }
    this.wrapper.removeEventListener("nodehover", this.onNodeHover)
    this.wrapper.removeEventListener("nodeunhover", this.onNodeUnhover)
    if (this.svg && this.svg.parentNode) {
      this.svg.parentNode.removeChild(this.svg)
    }
  }
}
